import React, { FunctionComponent, useState, useRef } from "react";
import { useDispatch,connect } from "react-redux";
import Loading from "../../Components/Loading/Loading";
import styles from "../AddOrganization/AddOrganization.module.css";
import { AiOutlineClose } from "react-icons/ai";
import TextInput from "../../Components/TextInput/TextInput";
import { emailValidate, phoneValidate , gstValidate} from "../../Values/validatorsnew";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import { countryData,domainData,organizationStatus } from "../../Values/constants";
import { useEffect } from "react";
import { editOrganization } from "../../Services/organizations";
import { themeColors } from "../../Components/theme";
import Label from "../../Components/Label";
import Firebase from "firebase/app";
import moment from "moment";
import { googleAnalytics } from "../../Services/users";

type props = {
  history: any;
  theme: any;
  authToken?: any;
};

const EditOrganization: FunctionComponent<props> = ({ history,theme,authToken }) => {
  const dispatcher = useDispatch();
  const location: any = useLocation();
  const [load, setLoad] = useState(false);

  const organizationNameRef: any = useRef();
  const mobileNumberRef: any = useRef();
  const emailRef: any = useRef();
  const contactemailRef: any = useRef();
  const contactnoRef: any = useRef();
  const cityRef: any = useRef();
  const addressRef: any = useRef();
  const pincodeRef: any = useRef();

  const employeesRef: any = useRef();
  const [businessDomain, setBusinessDomain]:any = useState("");

  const costPerLicenseRef: any = useRef();
  const gracePeriodRef: any = useRef();
  const validFromRef: any = useRef();
  const validTillRef: any = useRef();
  const gstNumberRef: any = useRef();
  const [shiftActiveStatus, setShiftActiveStatus]:any = useState("");
  const [organizationActiveStatus, setOrganizationActiveStatus]:any = useState("");

  // const getFormattedDate = (timestamp:any) => {
  //   if (typeof timestamp !== 'object' || !timestamp?.toDate) {
  //   }
  //   else{
  //     const date = timestamp.toDate();
  //   const year = date.getFullYear();
  //   const month = ('0' + (date.getMonth() + 1)).slice(-2);
  //   const day = ('0' + date.getDate()).slice(-2);
  //   const formattedDate = `${year}-${month}-${day}`;
  //   return formattedDate;
  //   }
  // }
  // console.log("location.state.detail?.valid_from",location.state.detail?.valid_from)
  const getFormattedDate = (date: any) => {
    // console.log("datdatedate",date)
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    // console.log("formattedDate",formattedDate)
    return formattedDate;
  };
  // const getFormattedDate = (date: Date) => {
  //   const year = date.getFullYear();
  //   const month = String(date.getMonth() + 1);
  //   const day = String(date.getDate());
  //   const isoDate = `${year}-${month}-${day}`;
  //   return isoDate;
  // };
  useEffect(() => {
    if (location.state !== undefined) {
      setBusinessDomain({
        label: location.state.detail.business_domain,
        value: location.state.detail.business_domain,
      });
      setShiftActiveStatus({
        label: location.state.detail.current_active_status === true?"True":'False',
        value: location.state.detail.current_active_status === true?"True":'False',
      });
      setOrganizationActiveStatus({
        label: location.state.detail.organization_active_status === true?"True":'False',
        value: location.state.detail.organization_active_status === true?"True":'False',
      });
    }
  }, []);

  const handleCheck = () => {
    return true
  }
  
  const editOrganizationDetails = (e:any) => {
    e.preventDefault();
    const val = handleCheck();
    if (val) {
    setLoad(true);
    editOrganization(
      location.state.detail.organization_id,
      organizationNameRef.current.value,
      mobileNumberRef.current.value,
      emailRef.current.value,
      addressRef.current.value,
      location.state.detail.country,
      location.state.detail.state,
      cityRef.current.value,
      pincodeRef.current.value,
      location.state.detail.admin_first_name,
      location.state.detail.admin_last_name,
      location.state.detail.admin_contact_number,
      location.state.detail.admin_email_id,
      contactemailRef.current.value,
      contactnoRef.current.value,
      employeesRef.current.value,
      location.state.detail.auth_id,
      businessDomain.value,
      history,
      dispatcher,
      (data) => setLoad(data),
      costPerLicenseRef.current.value,
      gracePeriodRef.current.value,
      validFromRef.current.value,
      validTillRef.current.value,
      gstNumberRef.current.value,
      shiftActiveStatus?.value === 'True'?true:false,
      organizationActiveStatus?.value === 'True'?true:false,
      authToken
    );
    }
  };

  const domainChoice = () => {
    let data = domainData.map((item: any, index: number) => ({
      value: item,
      label: item,
    }));

    return data;
  };
  const organizationChoice = () => {
    let data = organizationStatus.map((item: any, index: number) => ({
      value: item,
      label: item,
    }));

    return data;
  };
  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const selectInputContainerStyles = { width: "140px", marginRight: "5px" };
  useEffect(()=>{
    googleAnalytics('Edit_Organization_Screen')
  },[])
  // console.log("location.state.detaillllllllllllllllllllllllllll",location.state.detail.created_at)
  return (
    // <div className={styles.parent}>
    //   {load === true && <Loading />}
    //   <div className={styles.child}>
    //     <div className={styles.headerView}>
    //       <p className={styles.heading}> Edit Organization Details</p>
    //       <AiOutlineClose
    //         className={styles.closeIcon}
    //         size={25}
    //         onClick={() => history.replace("/")}
    //       />
    //     </div>
    //     <div className={styles.title}>
    //       <p className={styles.one}>Organization Name</p>
    //       <p className={styles.two}></p>
    //     </div>
    //     <div className={styles.box}>
    //       <TextInput
    //         title={"Enter Name"}
    //         style={{ backgroundColor: "#fff" }}
    //         ref={organizationNameRef}
    //         value={location.state.detail.organization_name}
    //       ></TextInput>
    //     </div>

    //     <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Mobile Number</p>
    //           <p className={styles.two}></p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter Number"}
    //             style={{ backgroundColor: "#fff" }}
    //             ref={mobileNumberRef}
    //             validator={phoneValidate}
    //             length={true}
    //             value={location.state.detail.mobile_number}
    //           />
    //         </div>
    //       </div>

    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Email Id</p>
    //           <p className={styles.two}></p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter Email"}
    //             style={{ backgroundColor: "#fff" }}
    //             ref={emailRef}
    //             validator={emailValidate}
    //             value={location.state.detail.email_id}
    //           />
    //         </div>
    //       </div>
    //     </div>

    //     <div style={{ marginTop: "22px" }} className={styles.title}>
    //       <p className={styles.one}>Address</p>
    //       <p className={styles.two}></p>
    //     </div>
    //     <div className={styles.box}>
    //       <TextInput
    //         title={"Enter Address"}
    //         style={{ backgroundColor: "#fff" }}
    //         ref={addressRef}
    //         value={location.state.detail.address}
    //       />
    //     </div>

    //     <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>CITY</p>
    //           <p className={styles.two}></p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter City"}
    //             style={{ backgroundColor: "#fff" }}
    //             ref={cityRef}
    //             value={location.state.detail.city}
    //           />
    //         </div>
    //       </div>

    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>PINCODE</p>
    //           <p className={styles.two}></p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter Pincode"}
    //             style={{ backgroundColor: "#fff" }}
    //             ref={pincodeRef}
    //             value={location.state.detail.pincode}
    //           />
    //         </div>
    //       </div>
    //     </div>

    //     <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>NUMBER OF EMPLOYEES</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter Number Of Employees"}
    //             style={{ backgroundColor: "#fff" }}
    //             ref={employeesRef}
    //             value={location.state.detail.no_of_employees}
    //           />
    //         </div>
    //       </div>
    //     </div>

    //     <button
    //       className={styles.button}
    //       onClick={() => {
    //         editOrganizationDetails();
    //       }}
    //     >
    //       Submit
    //     </button>
    //   </div>
    // </div>
    <div className={styles.parent} style={containerStyles}>
      {load === true && <Loading />}
      <div
        // className={styles.headerView}   
        className="d-flex flex-row w-100 px-4 pt-4">
        <h5
        // className={styles.heading}
        > Edit Organization Details</h5>
        <AiOutlineClose
          className={styles.closeIcon}
          size={25}
          onClick={() => history.replace("/")}
        />
      </div>
      <div
        // className={styles.child}
        className="w-100 d-flex flex-column gap-2 px-4"
      >
        <form className="card p-4 shadow rounded mt-2" style={cardContainerStyles}>
          <div className={styles.box2}>
            <div className={styles.divide}>
              <Label label="Organization Name" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={"Enter Name"}
                  style={{ backgroundColor: "#fff" }}
                  ref={organizationNameRef}
                  value={location.state.detail.organization_name}
                ></TextInput>
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Mobile Number" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={"Enter Number"}
                  style={{ backgroundColor: "#fff" }}
                  ref={mobileNumberRef}
                  validator={phoneValidate}
                  length={true}
                  value={location.state.detail.mobile_number}
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Email Id" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={"Enter Email"}
                  style={{ backgroundColor: "#fff" }}
                  ref={emailRef}
                  validator={emailValidate}
                  value={location.state.detail.email_id}
                />
              </div>
            </div>
          </div>

          <div className={styles.box2}>
            <div className={styles.divide}>
              <Label label="Address" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={"Enter Address"}
                  style={{ backgroundColor: "#fff" }}
                  ref={addressRef}
                  value={location.state.detail.address}
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="City" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={"Enter City"}
                  style={{ backgroundColor: "#fff" }}
                  ref={cityRef}
                  value={location.state.detail.city}
                />
              </div>
            </div>

            <div className={styles.divide}>
              <Label label="Pincode" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={"Enter Pincode"}
                  style={{ backgroundColor: "#fff" }}
                  ref={pincodeRef}
                  value={location.state.detail.pincode}
                />
              </div>
            </div>
          </div>

          <div className={styles.box2}>
            <div className={styles.divide}>
              <Label label="Number Of Employees" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={"Enter Number Of Employees"}
                  style={{ backgroundColor: "#fff" }}
                  ref={employeesRef}
                  value={location.state.detail.no_of_employees}
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Contact Email Id" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={"Enter Email"}
                  style={{ backgroundColor: "#fff" }}
                  ref={contactemailRef}
                  validator={emailValidate}
                  value={location.state.detail.contact_person_email}
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Contact Mobile No." required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={"Enter Number"}
                  style={{ backgroundColor: "#fff" }}
                  ref={contactnoRef}
                  validator={phoneValidate}
                  length={true}
                  value={location.state.detail.contact_person_no}
                />
              </div>
            </div>
          </div>
          <div className={styles.box2}>
            <div className={styles.divide}>
              <Label label="Domain" required={true} />
              <div style={{ color: "#000", ...selectInputContainerStyles }} >
                <Select
                  options={domainChoice()}
                  onChange={(data) => {
                    setBusinessDomain(data);
                  }}
                  isSearchable={true}
                  value={businessDomain}
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Cost Per License" required={false} />
              <div className={styles.inputContainer}>
                <TextInput
                  type={"number"}
                  title={"cost Per License"}
                  style={{ backgroundColor: "#fff" }}
                  ref={costPerLicenseRef}
                  value={location.state.detail?.cost_per_license}
                />
              </div>
            </div>
<div className={styles.divide}>
              <Label label="Grace Period" required={false} />
              <div className={styles.inputContainer}>
                <TextInput
                  type={"number"}
                  title={"Enter Grace Period"}
                  style={{ backgroundColor: "#fff" }}
                  ref={gracePeriodRef}
                  value={location.state.detail?.grace_period}
                />
              </div>
            </div>
          </div>
          <div className={styles.box2}>
            <div className={styles.divide}>
              <Label label="Valid From" required={false} />
              <div className={styles.inputContainer}>
                <TextInput
                  type={"date"}
                  title={"Valid From"}
                  style={{ backgroundColor: "#fff" }}
                  ref={validFromRef}
                  value={getFormattedDate(new Date(location.state.detail?.valid_from))}
                  
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Valid Till" required={false} />
              <div className={styles.inputContainer}>
                <TextInput
                  type={"date"}
                  title={"Valid Till"}
                  style={{ backgroundColor: "#fff" }}
                  ref={validTillRef}
                  value={getFormattedDate(new Date(location.state.detail?.valid_till))}
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="GST Number" required={false} />
              <div className={styles.inputContainer}>
                <TextInput
                  type={"text"}
                  title={"Enter GST Number"}
                  style={{ backgroundColor: "#fff" }}
                  ref={gstNumberRef}
                  validator={gstValidate}
                  value={location.state.detail?.GSTIN}
                />
              </div>
            </div>
          </div>
          <div className={styles.box2}>
          <div className={styles.divide}>
              <Label label="Shift Active Status" required={true} />
              <div style={{ color: "#000", ...selectInputContainerStyles }} >
                <Select
                  options={organizationChoice()}
                  onChange={(data) => {
                    setShiftActiveStatus(data);
                  }}
                  isSearchable={true}
                  value={shiftActiveStatus}
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Organization Active Status" required={true} />
              <div style={{ color: "#000", ...selectInputContainerStyles }} >
                <Select
                  options={organizationChoice()}
                  onChange={(data) => {
                    setOrganizationActiveStatus(data);
                  }}
                  isSearchable={true}
                  value={organizationActiveStatus}
                />
              </div>
            </div>
            <div className={styles.divide}>
              {/* <Label label="Domain" required={true} /> */}
              <div style={{ color: "#000", ...selectInputContainerStyles }} >
                {/* <Select
                  options={domainChoice()}
                  onChange={(data) => {
                    setBusinessDomain(data);
                  }}
                  isSearchable={true}
                  value={businessDomain}
                /> */}
              </div>
            </div>
          </div>
          <button
            className={styles.button}
            onClick={(e:any) => {
              editOrganizationDetails(e);
            }}
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    theme: state.theme.isLightMode,
    authToken: state.user.authToken
  };
};

export default connect(mapStateToProps)(EditOrganization);

